module.exports = __webpack_public_path__ + "img/news-right02.eaa27dcd.png";